import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// The app now looks inside your hidden .env file for these values!
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check AFTER first paint. The reCaptcha Enterprise script is
// large and can stall main-thread work on mobile, delaying the landing page.
// Auth state and Firestore reads work fine without App Check having resolved
// yet — the token attaches as soon as it's ready.
const initAppCheck = () => {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(process.env.REACT_APP_RECAPTCHA_KEY),
      isTokenAutoRefreshEnabled: true
    });
  } catch (e) {
    console.warn('App Check init failed, continuing without it:', e);
  }
};
if (typeof window !== 'undefined') {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(initAppCheck, { timeout: 3000 });
  } else {
    setTimeout(initAppCheck, 1500);
  }
}

// Export the Authentication and Database tools so the rest of your app can use them
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);